<h1 class="text-center" [innerHTML]="'pageerror.notfound.title' | translate"></h1>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-3">
    <app-advisor-image path="/moc/moc-ausstieg.svg" [altText]="'moderat.verbrauchsanalyse.ausstieg.alt_text' | translate"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-9 large-8">
    <p [innerHTML]="('pageerror.notfound.text') | translate"></p>
  </div>
</div>

<app-step-buttons [previousLink]="lastStep" previousText="pageerror.notfound.button" [nextLink]="null" [nextSubmit]="false" mediumWidthRight="9" mediumOffset="3" leftAlignSize="medium" largeOffset="3" largeWidthRight="8" nextText="moderat.verbrauchsanalyse.start.next"></app-step-buttons>

